import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Box, Paper, Tab, Tabs, Typography, withStyles } from '@material-ui/core';
import { updateURL } from '../../sc-utilities';
import ControlMachine from '../../sc-dashboard/ControlMachine';
import MobileEraseStation from '../../sc-dashboard/MobileEraseStation';
import RaspberryEraseStation from "../../sc-dashboard/RaspberryEraseStation";
import {hasPermission} from "../../sc-utilities";

const styles = theme => ({
    root: {
        width: `98.9%`,
        height: 'auto',
        paddingLeft: theme.spacing(),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            width: '100%'
        }
    },
    paper: {
        marginTop: theme.spacing(),
        padding: theme.spacing(2),
        marginBottom: theme.spacing(-2)
    },
    tabs: {
        marginLeft: theme.spacing(-5)
    },
});

const TabContainer = props => {
    return (
        <Typography component="div" dir={props.dir} style={{ padding: 6, marginTop: '1%' }}>
            {props.children}
        </Typography>
    );
};

const getTabValue = () => {
    let urlArray = window.location.href.split('#');
    return urlArray.length > 1 ? Number(urlArray[1]) : 0;
};

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index || props.disabled}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {(value === index || value < 3) && (
                <Box p={3} style={{ padding: '0px' }} disabled={true}>
                    {children}
                </Box>
            )}
        </div>
    );
}

const InstalledSoftware = props => {
    const { classes, theme, translations, permissions } = props;
    const [tabValue, setTabValue] = useState(getTabValue());

    const handleChange = (event, value) => {
        updateURL(value);
        setTabValue(value);
    };

    return (
        <div className={classes.root}>
            <Paper className={classes.paper} >
                <div className={classes.tabs}>
                    <Tabs
                        value={tabValue}
                        onChange={handleChange}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="fullWidth"
                        scrollButtons="on"
                    >
                        <Tab label={translations["control_machine"] || "Command"} />
                        <Tab label={translations["mobile_erase_station"] || "Mobile station"} />
                        {hasPermission(permissions, 'raspberry_erase_station_list') && <Tab label={translations["raspberry_erase_station"] || "Work Dongle"} />}
                    </Tabs>
                </div>
            </Paper>
            <TabPanel index={0} value={tabValue}><TabContainer dir={theme.direction}><ControlMachine /></TabContainer></TabPanel>
            <TabPanel index={1} value={tabValue}><TabContainer dir={theme.direction}><MobileEraseStation /></TabContainer></TabPanel>
            {hasPermission(permissions, 'raspberry_erase_station_list') && <TabPanel index={2} value={tabValue}><TabContainer dir={theme.direction}><RaspberryEraseStation /></TabContainer></TabPanel>}
        </div>
    );
};

const mapStateToProps = state => {
    return {
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || [],
    };
};

export default connect(
    mapStateToProps,
    null
)(withStyles(styles, { withTheme: true })(InstalledSoftware));
